import React, { useState, useRef } from 'react';
import { SettingsCard } from './shared/SettingsCard';
import { Camera, Upload, X, Music, Heart, Wallet } from 'lucide-react';
interface ProfileSectionProps {
  setHasUnsavedChanges: (hasChanges: boolean) => void;
}
export const ProfileSection: React.FC<ProfileSectionProps> = ({
  setHasUnsavedChanges
}) => {
  const [profile, setProfile] = useState({
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/un38DJe1eXRzCTbzg1byc9/blue_male_eyes.jpg',
    banner: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1KN72KTjhp8HuxCRdTPkmK/profile_banner_fire.jpg',
    username: 'Mitch',
    displayName: 'Mitch',
    bio: 'AI enthusiast. Looking for meaningful connections in a digital world. SinShift VIP member.',
    location: 'Los Angeles, CA',
    website: 'https://example.com',
    amazonWishlist: 'https://amazon.com/wishlist/abc123',
    spotifyConnected: false,
    interests: ['AI', 'Technology', 'Photography', 'Music', 'Travel']
  });
  const availableInterests = ['AI', 'Technology', 'Photography', 'Music', 'Travel', 'Gaming', 'Fitness', 'Fashion', 'Food', 'Art', 'Movies', 'Books', 'Sports', 'Dancing', 'Yoga', 'Pets', 'Nature', 'Cooking', 'Writing', 'Meditation'];
  const fileInputRef = useRef<HTMLInputElement>(null);
  const bannerInputRef = useRef<HTMLInputElement>(null);
  const handleInputChange = (field: string, value: string) => {
    setProfile(prev => ({
      ...prev,
      [field]: value
    }));
    setHasUnsavedChanges(true);
  };
  const handleInterestToggle = (interest: string) => {
    setProfile(prev => {
      const newInterests = prev.interests.includes(interest) ? prev.interests.filter(i => i !== interest) : [...prev.interests, interest];
      return {
        ...prev,
        interests: newInterests
      };
    });
    setHasUnsavedChanges(true);
  };
  const handleAvatarUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = event => {
        setProfile(prev => ({
          ...prev,
          avatar: event.target?.result as string
        }));
        setHasUnsavedChanges(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleBannerUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = event => {
        setProfile(prev => ({
          ...prev,
          banner: event.target?.result as string
        }));
        setHasUnsavedChanges(true);
      };
      reader.readAsDataURL(file);
    }
  };
  return <div className="divide-y divide-gray-200 dark:divide-gray-800" data-id="element-18780">
      <SettingsCard title="Profile Information" description="Update your profile information and how others see you on SinShift." data-id="element-18781">
        {/* Banner Upload */}
        <div className="mb-6" data-id="element-18782">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-18783">
            Profile Banner
          </label>
          <div className="relative h-40 rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-800" data-id="element-18784">
            {profile.banner && <img src={profile.banner} alt="Profile Banner" className="w-full h-full object-cover" data-id="element-18785" />}
            <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity" data-id="element-18786">
              <div className="flex gap-2" data-id="element-18787">
                <button className="p-2 bg-white dark:bg-gray-800 rounded-full" onClick={() => bannerInputRef.current?.click()} data-id="element-18788">
                  <Camera size={18} className="text-gray-700 dark:text-gray-300" data-id="element-18789" />
                </button>
                {profile.banner && <button className="p-2 bg-white dark:bg-gray-800 rounded-full" onClick={() => {
                setProfile(prev => ({
                  ...prev,
                  banner: ''
                }));
                setHasUnsavedChanges(true);
              }} data-id="element-18790">
                    <X size={18} className="text-red-500" data-id="element-18791" />
                  </button>}
              </div>
            </div>
          </div>
          <input type="file" ref={bannerInputRef} className="hidden" accept="image/*" onChange={handleBannerUpload} data-id="element-18792" />
        </div>
        {/* Avatar Upload */}
        <div className="mb-6" data-id="element-18793">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-18794">
            Profile Avatar
          </label>
          <div className="flex items-center gap-4" data-id="element-18795">
            <div className="relative" data-id="element-18796">
              <div className="w-24 h-24 rounded-full overflow-hidden bg-gray-100 dark:bg-gray-800 border-2 border-white dark:border-gray-700 shadow-md" data-id="element-18797">
                <img src={profile.avatar} alt="Avatar" className="w-full h-full object-cover" data-id="element-18798" />
              </div>
              <button className="absolute bottom-0 right-0 p-1.5 bg-white dark:bg-gray-800 rounded-full border border-gray-200 dark:border-gray-700 shadow-sm" onClick={() => fileInputRef.current?.click()} data-id="element-18799">
                <Camera size={14} className="text-gray-700 dark:text-gray-300" data-id="element-18800" />
              </button>
            </div>
            <div data-id="element-18801">
              <button className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 rounded text-sm text-gray-700 dark:text-gray-300 flex items-center gap-1.5" onClick={() => fileInputRef.current?.click()} data-id="element-18802">
                <Upload size={14} data-id="element-18803" />
                <span data-id="element-18804">Upload new avatar</span>
              </button>
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-18805">
                JPG, PNG or GIF. Max 2MB.
              </p>
            </div>
          </div>
          <input type="file" ref={fileInputRef} className="hidden" accept="image/*" onChange={handleAvatarUpload} data-id="element-18806" />
        </div>
        {/* Username - Read Only */}
        <div className="mb-4" data-id="element-18807">
          <label htmlFor="username" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-18808">
            Username
          </label>
          <input type="text" id="username" value={profile.username} readOnly className="w-full px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md text-gray-700 dark:text-gray-300 cursor-not-allowed" data-id="element-18809" />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-18810">
            Your username cannot be changed.
          </p>
        </div>
        {/* Display Name */}
        <div className="mb-4" data-id="element-18811">
          <label htmlFor="displayName" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-18812">
            Display Name
          </label>
          <input type="text" id="displayName" value={profile.displayName} onChange={e => handleInputChange('displayName', e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-500 dark:focus:ring-purple-500" maxLength={50} data-id="element-18813" />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-18814">
            This is the name that will be displayed to other users.
          </p>
        </div>
        {/* Bio */}
        <div className="mb-4" data-id="element-18815">
          <label htmlFor="bio" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-18816">
            Bio
          </label>
          <textarea id="bio" value={profile.bio} onChange={e => handleInputChange('bio', e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-500 dark:focus:ring-purple-500" rows={4} maxLength={1000} data-id="element-18817" />
          <div className="mt-1 flex justify-between items-center" data-id="element-18818">
            <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-18819">
              Tell others about yourself.
            </p>
            <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-18820">
              {profile.bio.length}/1000
            </span>
          </div>
        </div>
        {/* Location */}
        <div className="mb-4" data-id="element-18821">
          <label htmlFor="location" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-18822">
            Location
          </label>
          <input type="text" id="location" value={profile.location} onChange={e => handleInputChange('location', e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-500 dark:focus:ring-purple-500" maxLength={64} data-id="element-18823" />
        </div>
        {/* Website */}
        <div className="mb-4" data-id="element-18824">
          <label htmlFor="website" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-18825">
            Website
          </label>
          <input type="url" id="website" value={profile.website} onChange={e => handleInputChange('website', e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-500 dark:focus:ring-purple-500" maxLength={100} data-id="element-18826" />
        </div>
        {/* Amazon Wishlist */}
        <div className="mb-4" data-id="element-18827">
          <label htmlFor="amazonWishlist" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-18828">
            Amazon Wishlist URL
          </label>
          <input type="url" id="amazonWishlist" value={profile.amazonWishlist} onChange={e => handleInputChange('amazonWishlist', e.target.value)} className="w-full px-3 py-2 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-500 dark:focus:ring-purple-500" maxLength={100} data-id="element-18829" />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-18830">
            Let your fans know what gifts you'd like to receive.
          </p>
        </div>
      </SettingsCard>
      <SettingsCard title="Additional Information" description="Connect additional accounts and share your interests." data-id="element-18831">
        {/* Spotify Integration */}
        <div className="mb-6" data-id="element-18832">
          <div className="flex items-center justify-between" data-id="element-18833">
            <div data-id="element-18834">
              <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center gap-2" data-id="element-18835">
                <Music size={16} className="text-green-500" data-id="element-18836" />
                Spotify Account
              </h4>
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-18837">
                Connect your Spotify account to share what you're listening to.
              </p>
            </div>
            <button className={`px-3 py-1.5 rounded text-sm font-medium ${profile.spotifyConnected ? 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' : 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'}`} onClick={() => {
            setProfile(prev => ({
              ...prev,
              spotifyConnected: !prev.spotifyConnected
            }));
            setHasUnsavedChanges(true);
          }} data-id="element-18838">
              {profile.spotifyConnected ? 'Disconnect' : 'Connect'}
            </button>
          </div>
        </div>
        {/* Interests/Things I Like */}
        <div className="mb-6" data-id="element-18839">
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center gap-2 mb-3" data-id="element-18840">
            <Heart size={16} className="text-pink-500" data-id="element-18841" />
            Things I Like
          </h4>
          <div className="flex flex-wrap gap-2" data-id="element-18842">
            {availableInterests.map(interest => <button key={interest} className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${profile.interests.includes(interest) ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => handleInterestToggle(interest)} data-id="element-18843">
                {interest}
              </button>)}
          </div>
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-18844">
            Select the things you're interested in to help others get to know
            you better.
          </p>
        </div>
        {/* NFT Wallet Connect */}
        <div data-id="element-18845">
          <div className="flex items-center justify-between" data-id="element-18846">
            <div data-id="element-18847">
              <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center gap-2" data-id="element-18848">
                <Wallet size={16} className="text-purple-500" data-id="element-18849" />
                NFT Wallet
              </h4>
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-18850">
                Connect your wallet to display NFTs on your profile.
              </p>
            </div>
            <button className="px-3 py-1.5 bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400 rounded text-sm font-medium" data-id="element-18851">
              Connect Wallet
            </button>
          </div>
        </div>
      </SettingsCard>
    </div>;
};